import { msg } from "@lingui/core/macro";
import { createRoute, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { ChurchDetailPage } from "@/features/domain/components/church-detail-page";
import { useI18n } from "@/providers/i18n-provider";

function ChurchDetailRoutePage() {
  const { t } = useI18n();
  const params = useParams({ from: "/_app/churches/$churchId" });
  return (
    <AuthPlaceholder
      title={t(msg`Church`)}
      description={t(msg`Sign in to manage this congregation.`)}
    >
      <PageContainer maxWidth="3xl">
        <ChurchDetailPage churchId={params().churchId} />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const churchDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/churches/$churchId",
  component: ChurchDetailRoutePage,
});
